import { AdminPopupImageEnum } from '@tymbe/schema/admin-popup.interface';
import TymbeEarImage from '../../assets/images/popup/tymbe_ear.png';
import TymbeHeartImage from '../../assets/images/popup/tymbe_heart.png';
import TymbeSosImage from '../../assets/images/popup/tymbe_sos.png';
import TymbeThumbsUpImage from '../../assets/images/popup/tymbe_thumbs_up.png';
import TymbeTrophyImage from '../../assets/images/popup/tymbe_trophy.png';
import { TyInput } from '@tymbe/ui-forms';

export const imageEnumValues = [
  AdminPopupImageEnum.ear,
  AdminPopupImageEnum.heart,
  AdminPopupImageEnum.sos,
  AdminPopupImageEnum.thumbsUp,
  AdminPopupImageEnum.trophy,
];

export const images: Record<AdminPopupImageEnum, string> = {
  [AdminPopupImageEnum.ear]: TymbeEarImage,
  [AdminPopupImageEnum.heart]: TymbeHeartImage,
  [AdminPopupImageEnum.sos]: TymbeSosImage,
  [AdminPopupImageEnum.thumbsUp]: TymbeThumbsUpImage,
  [AdminPopupImageEnum.trophy]: TymbeTrophyImage,
};

interface AdminPopupImageSelectorProps {
  selectedImage: AdminPopupImageEnum;
  setSelectedImage: (img: AdminPopupImageEnum) => void;
  setFormValue: (img: AdminPopupImageEnum) => void;
}

const AdminPopupImageSelector = ({ selectedImage, setSelectedImage, setFormValue }: AdminPopupImageSelectorProps) => (
  <div className="flex flex-col gap-4 mb-4">
    <span className="text-caption-xl font-normal text-secondary-500">Obrázek popupu</span>
    <div className="flex gap-2">
      {imageEnumValues.map((imgKey) => {
        const selected = selectedImage === imgKey;
        return (
          <div
            key={imgKey}
            onClick={() => {
              setSelectedImage(imgKey);
              setFormValue(imgKey);
            }}
            className={`transition cursor-pointer border-2 rounded-lg p-1 ${selected ? 'border-primary-500' : 'border-transparent'}`}
          >
            <img src={images[imgKey]} alt={imgKey} className="w-14 h-14 object-contain" />
          </div>
        );
      })}
    </div>
    <TyInput name="image" className="hidden" />
  </div>
);

export default AdminPopupImageSelector;
